import { getParent } from 'mobx-state-tree';
import compact from 'lodash/compact';
import round from 'lodash/round';
import filter from 'lodash/fp/filter';
import flatten from 'lodash/flatten';
import groupBy from 'lodash/fp/groupBy';
import sortBy from 'lodash/fp/sortBy';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import { categories, azimut2cardinal, getMinMax, getSeries, getSeriesName } from '~/utils/wind_rose';
import type { IDeviceMonitor } from '../..';
import type { IChartTableWidgetStore } from '..';

export { categories, azimut2cardinal, getSeries };

export default (self: IChartTableWidgetStore) => {
  function getData() {
    const report = getParent<IDeviceMonitor>(self, 3);
    return compact(report?.params.selected_params_wind_chart?.map((id) => self.node?.data_points?.getById(id)));
  }
  return {
    get windChartData() {
      return flow(
        compact,
        flatten,
        groupBy('ts'),
        Object.values,
        map((item) => {
          const { direction } = item.find(({ direction }) => direction != null) || {};

          const { speed } = item.find(({ speed }) => speed != null) || {};
          return { direction, speed };
        }),
        filter(({ speed }) => speed != null)
      )(
        getData().map((dp) =>
          dp.measurements.map(([ts, value]) => ({ ts, ...(dp.isWindDirection ? { direction: azimut2cardinal(value) } : { speed: value }) }))
        )
      );
    },
    get windChartSeries() {
      if (getData().length === 2) {
        const windDirection = getData().find((dp) => !dp.isWindDirection);
        const data = self.windChartData;
        const total = data.length;
        const series = getSeries(data, windDirection?.unit);
        return flow(
          groupBy(({ speed }) => getSeriesName(series, speed)),
          Object.entries,
          map(([name, items]) => {
            return {
              name,
              ...getMinMax(items),
              data: categories.map((category) => {
                const count = items.filter(({ direction }) => direction === category).length;
                const frequency = round((count / total) * 100, 2);
                return [category, frequency || 0];
              })
            };
          }),
          sortBy(['min'])
        )(data);
      }
      return [];
    }
  };
};
